import * as tslib_1 from "tslib";
import loader from "@/components/loader.vue";
import { Action, Mutation } from "vuex-class";
import { Vue, Component, Prop } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.lastErr = "";
    }
    async deleteAccount() {
        this.loading = true;
        try {
            await this.authDeleteAccount();
            this.$emit("input", 0);
        }
        catch (err) {
            this.setLastErr(err);
        }
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], widget.prototype, "value", void 0);
tslib_1.__decorate([
    Mutation("setLastErr")
], widget.prototype, "setLastErr", void 0);
tslib_1.__decorate([
    Action("auth/deleteAccount")
], widget.prototype, "authDeleteAccount", void 0);
widget = tslib_1.__decorate([
    Component({ components: { loader } })
], widget);
export default widget;
